import { gql } from 'graphql-request';

export const getPinyins = gql`
  query GetPinyins(
    $page: Int = 1
    $limit: Int = 10
    $vowel: String
    $tone: Int
  ) {
    getPinyins(page: $page, limit: $limit, vowel: $vowel, tone: $tone) {
      count
      next
      previous
      results {
        id
        vowel
        tone
      }
      totalPages
    }
  }
`;

export const getMaps = gql`
  query GetMaps($page: Int = 1, $limit: Int = 10, $tone: Int) {
    getMaps(page: $page, limit: $limit, tone: $tone) {
      count
      next
      previous
      results {
        id
        tone
      }
      totalPages
    }
  }
`;
